import { render, staticRenderFns } from "./DocsColorBlock.vue?vue&type=template&id=525c2506&scoped=true&"
import script from "./DocsColorBlock.vue?vue&type=script&lang=js&"
export * from "./DocsColorBlock.vue?vue&type=script&lang=js&"
import style0 from "./DocsColorBlock.vue?vue&type=style&index=0&id=525c2506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c2506",
  null
  
)

export default component.exports